import { DEFAULT_LANGUAGE, LANGUAGES } from "../../Constants/i18n";

// Idioma guardado, o el del navegador en la primera visita
export const getInitialLanguage = () => {
  try {
    const saved = localStorage.getItem("language");
    if (LANGUAGES.includes(saved)) return saved;
  } catch (e) {}
  const browser = (navigator.language || "").slice(0, 2).toLowerCase();
  return LANGUAGES.includes(browser) ? browser : DEFAULT_LANGUAGE;
};
